import { render } from "./MyofficeDashBoard.vue?vue&type=template&id=86b0f79a"
import script from "./MyofficeDashBoard.vue?vue&type=script&lang=js"
export * from "./MyofficeDashBoard.vue?vue&type=script&lang=js"

import "./MyofficeDashBoard.vue?vue&type=style&index=0&id=86b0f79a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__